import { useEffect, useRef } from 'react'
import { isMobile } from 'react-device-detect'

import usePublications from 'hooks/usePublications/usePublications'
import useTrack from 'hooks/useTrack/useTrack'

import { useAppState } from '../../state'

const AUDIO_TRACK_NAME = 'data-cy-audio-track-name'
const AUDIO = 'audio'

export default function AudioTrack({ participant }) {
    const { activeSinkId } = useAppState(),
        audioEl = useRef(),
        publications = usePublications(participant),
        audioPublication = publications.find(p => p.kind === AUDIO),
        audioTrack = useTrack(audioPublication)

    useEffect(() => {
        if (!audioTrack) return
        audioEl.current = audioTrack.attach()
        audioEl.current.setAttribute(AUDIO_TRACK_NAME, audioTrack.name)
        document.body.appendChild(audioEl.current)
        return () => audioTrack.detach().forEach(el => el.remove())
    }, [audioTrack])

    useEffect(() => {
        if (audioEl.current && audioEl.current.setSinkId && !isMobile) {
            audioEl.current.setSinkId(activeSinkId)
        }
    }, [activeSinkId])

    console.count('AudioTrack Component')

    return null
}
